// Login-specific messages: never display raw server responses or exception text.
import { ACTIVE_BROWSER_SESSION } from "./browserSessionGuard";
export const LOGIN_TIMEOUT_MS = 20000;

const support = "Kontaktoni administratorin ose info@quantifynexus.com.";

export function getLoginErrorMessage(error, online = true) {
  if (error?.code === ACTIVE_BROWSER_SESSION) return error.message;
  const status = Number(error?.response?.status);
  const data = error?.response?.data;

  if (status) {
    if (status === 400 && data?.message === "CompanyID nuk është valid.") {
      return `Llogaria juaj nuk është lidhur siç duhet me biznesin. ${support}`;
    }
    if (status === 400 && data?.errors) {
      return "Të dhënat e hyrjes nuk u pranuan. Kontrolloni emailin dhe fjalëkalimin dhe provoni përsëri.";
    }
    if (status === 400 || status === 401) {
      return "Emaili ose fjalëkalimi është i pasaktë. Kontrolloni të dhënat dhe provoni përsëri.";
    }
    if (status === 403) {
      if (data?.error === "LICENSE_BLOCKED") {
        const licenseMessages = {
          Expired: "Licenca e biznesit ka skaduar. Për të vazhduar hyrjen, kërkoni rinovimin e saj.",
          Suspended: "Licenca e biznesit është pezulluar. Hyrja është përkohësisht e kufizuar.",
          Missing: "Biznesi nuk ka një licencë aktive për hyrje.",
        };
        return `${licenseMessages[data.status] || "Licenca e biznesit nuk lejon hyrjen aktualisht."} ${support}`;
      }
      return `Llogaria juaj nuk ka leje për të hyrë në platformë. ${support}`;
    }
    if (status === 408 || status === 504) {
      return "Serveri nuk u përgjigj në kohë. Provoni përsëri pas pak. Nëse problemi vazhdon, kontaktoni mbështetjen.";
    }
    if (status === 429) {
      return "Janë bërë shumë tentativa hyrjeje. Prisni disa minuta para se të provoni përsëri.";
    }
    if (status === 502 || status === 503) {
      return "Shërbimi i hyrjes është përkohësisht i padisponueshëm. Provoni përsëri pas pak. Nëse problemi vazhdon, kontaktoni mbështetjen.";
    }
    if (status >= 500) {
      return "Ndodhi një problem në server gjatë hyrjes. Provoni përsëri pas pak. Nëse problemi vazhdon, kontaktoni mbështetjen.";
    }
    if (status === 404 || status === 405) {
      return `Shërbimi i hyrjes nuk është i disponueshëm në këtë adresë. ${support}`;
    }
    return `Hyrja nuk u përfundua. Provoni përsëri. Nëse problemi vazhdon, ${support.toLowerCase()}`;
  }

  if (!online) {
    return "Duket se pajisja juaj nuk ka lidhje me internetin. Kontrolloni Wi-Fi ose të dhënat mobile dhe provoni përsëri.";
  }
  if (error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT") {
    return "Serveri nuk u përgjigj në kohë. Kontrolloni lidhjen e internetit dhe provoni përsëri pas pak.";
  }
  if (error?.request || error?.code === "ERR_NETWORK") {
    return "Nuk arritëm të lidhemi me serverin. Kontrolloni lidhjen e internetit dhe provoni përsëri. Nëse faqet e tjera hapen, provoni pas pak ose kontaktoni mbështetjen.";
  }
  return "Hyrja nuk u përfundua për shkak të një problemi të papritur. Rifreskoni faqen dhe provoni përsëri. Nëse problemi vazhdon, kontaktoni mbështetjen.";
}
